module.exports = __webpack_public_path__ + "img/85.3cd01765.jpg";